import { useApiQuery } from '../useApiQuery';
import { reviewKeys } from '@/lib/queryKeys';
import { reviewsV2Endpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { ExternalReviewDetail, ReviewResponseDetail, TestimonialDetail } from '@/types/review';

export type ReviewDetail = ReviewResponseDetail | ExternalReviewDetail | TestimonialDetail;

/**
 * Fetches one row by source + id.
 *
 * All three dashboard sources are tenant-scoped by the admin controller.
 */
export function useReviewDetail(
  source: 'response' | 'external' | 'testimonial',
  id: string | null,
  options: { enabled?: boolean } = {},
) {
  const enabled = options.enabled !== false && id != null && id.length > 0;
  return useApiQuery<{ data: ReviewDetail }>({
    queryKey: id ? reviewKeys.detail(source, id) : reviewKeys.details(),
    enabled,
    queryFn: async ({ signal }) => {
      return apiGet<{ data: ReviewDetail }>(
        operationsClient,
        reviewsV2Endpoints.detail(source, id!),
        { signal },
      );
    },
    showErrorToast: false,
  });
}
